

<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
 <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> --><div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
 </div>
 <div *ngIf="loaded">
        <section *ngIf="!showPassReset" class="login-main-wrapper full-height">
                <div class="container-fluid pl-0 pr-0">
                    <div class="row no-gutters row justify-content-center ">
                        <div class="col-md-5 p-5 bg-dark-style authbox">
                           <div class="login-main-left">
                              <div class="text-center mb-5 login-main-left-header">
                                 <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                                 
                                   </div>
                                 
                              <div class="text-center">
                                <br/><br/>
                               <h3 i18n="@@Setting Password | Setting Password message" class="pulsate">Setting Password...</h3>
                                 </div>
                           </div>
                        </div>
                  </div>
                </div>
             </section>
<div class="container-fluid mt-2">
          <div class="row">
        <div class="col-md-12">
  <div class="row">
      <div class="col-md-4 p-5 offset-md-4 mt-2">
          <span *ngIf="!subSite">
              <div class="channels-card">
                  <div class="channels-card-body">
                      <div class="channels-title sitesub">
                                    <div *ngIf="showPassReset" class="col-sm-12">
                                      <div class="form-group">
                                         <label i18n="@@Set Password | Set Password message" class="control-label">Set Password* </label>
                                         <input minlength=6 (keyup)="onPasswordKeyUp($event)" class="form-control border-form-control" value="" placeholder="" type="password">
                                      </div>
                                   </div>
                                   <div *ngIf="showPassReset" class="col-sm-12">
                                       <div class="form-group">
                                          <label i18n="@@Set Password Again | Set Password Again message" class="control-label">Type Password Again* </label>
                                          <input minlength=6 (keyup)="onPasswordDoubleKeyUp($event)" class="form-control border-form-control" value="" placeholder="" type="password">
                                       </div>
                                       <div *ngIf="passShort" class="warning"><p i18n="@@Password too short | Password too short message">Password is too short, must be more than 6 characters in length</p></div>
                                    </div>
                                    <div *ngIf="showPassReset" class="col-sm-12 mt-4">
                                   <button (click)="forgotUser()" class="form-control">
                                       <span i18n="@@Reset Password and Login | Reset Password Button">Set Password</span>
                                     </button></div>
                      </div>
                  </div>
              </div> </span>
        </div>
  </div>
  </div>
  </div>
</div>
</div>
